<template>
  <div id="app" v-cloak>
    <header class="bg-primary text-white">
      <div v-text="header.title" class="title"></div>
      <div v-text="header.subtitle" class="subtitle"></div>
    </header>
    <section class="container">
      <div class="box-search">
        <div class="search-input-wrapper">
          <font-awesome-icon icon="search" class="search-icon-inside" />
          <input 
            type="search" 
            v-model="search" 
            placeholder="¿Qué película quieres ver hoy?..." 
            @keyup.enter="searchFilm()"
          >
          <button v-show="checkSearch" class="btn-clear" @click="search = ''">
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <button class="btn-wow search-main-btn" @click="searchFilm()">
          <font-awesome-icon icon="play" /> BUSCAR AHORA
        </button>
        
        <div class="pagination-modern" v-show="showPagination">
          <button class="pag-btn" @click="previous()" :disabled="pagination.pagActual === 1">
            <font-awesome-icon icon="chevron-left" />
          </button>
          <span class="pag-info">{{printPages}}</span>
          <button class="pag-btn" @click="next()" :disabled="pagination.pagActual === pagination.totalPages">
            <font-awesome-icon icon="chevron-right" />
          </button>
        </div>
      </div>
      <div class="box-result">
        <ul v-show="showFilm" class="film-list-full">
          <li v-for="(film, index) in dataFilm" :key="index" class="film-card-premium">
            <div class="card-glow"></div>
            <div class="card-inner">
              <div :class="film.Poster !== 'N/A' ? 'image-container' : 'image-container border-placeholder'">
                <img :src="film.Poster !== 'N/A' ? film.Poster : noImage" alt="" class="poster-img">
              </div>
              <div class="data-content">
                <div class="id-badge">ID: {{film.imdbID}}</div>
                <h2 class="film-title-gradient">{{film.Title}}</h2>
                <div class="meta-row">
                  <span class="meta-item"><font-awesome-icon icon="calendar" /> {{film.Year}}</span>
                  <span class="meta-item"><font-awesome-icon icon="film" /> {{film.Type}}</span>
                </div>
                <div class="action-row">
                  <a :href="film.Poster" target="_blank" class="btn-wow">
                    <font-awesome-icon icon="download" /> Descargar Poster
                  </a>
                  <button @click="searchDetailFilm(film.imdbID, 'id')" class="btn-wow secondary">
                    <font-awesome-icon icon="info-circle" /> Ver Detalles Pro
                  </button>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div v-show="showDetailFilm" class="film-detail-cinematic animate-fade-in">
          <button class="btn-close" @click="dataDetailFilm = ''">
            <font-awesome-icon icon="times" /> Cerrar
          </button>
          
          <div class="detail-header">
            <div class="detail-poster-container">
              <img :src="dataDetailFilm.Poster" alt="" class="detail-poster">
              <div class="poster-overlay"></div>
            </div>
            
            <div class="detail-info-main">
              <div class="detail-top">
                <span class="badge-year">{{dataDetailFilm.Year}}</span>
                <span class="badge-rated">{{dataDetailFilm.Rated}}</span>
                <span class="badge-runtime">{{dataDetailFilm.Runtime}}</span>
              </div>
              
              <h1 class="detail-title">{{dataDetailFilm.Title}}</h1>
              <p class="detail-genre">{{dataDetailFilm.Genre}}</p>
              
              <div class="detail-ratings">
                <div v-for="(rating, index) in dataDetailFilm.Ratings" :key="index" class="rating-box">
                  <span class="rating-source">{{rating.Source}}</span>
                  <span class="rating-value">{{rating.Value}}</span>
                </div>
              </div>

              <div class="detail-plot">
                <h3>SINOPSIS</h3>
                <p>{{dataDetailFilm.Plot}}</p>
              </div>

              <div class="detail-grid">
                <div class="grid-item">
                  <span class="grid-label">DIRECTOR</span>
                  <span class="grid-value">{{dataDetailFilm.Director}}</span>
                </div>
                <div class="grid-item">
                  <span class="grid-label">ACTORES</span>
                  <span class="grid-value">{{dataDetailFilm.Actors}}</span>
                </div>
                <div class="grid-item">
                  <span class="grid-label">AWARDS</span>
                  <span class="grid-value">{{dataDetailFilm.Awards}}</span>
                </div>
              </div>
              
              <div class="detail-footer">
                <a :href="dataDetailFilm.Website" target="_blank" v-if="dataDetailFilm.Website !== 'N/A'" class="btn-wow">
                  <font-awesome-icon icon="globe" /> Visitar Web Oficial
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="error" v-show="showError">
        {{this.msnError}}
      </div>
      <div class="lds-ripple" v-show="showloading">
        <div></div>
        <div></div>
      </div>
    </section>
  </div>
</template>

<script>
import API from './servicios.js'
export default {
  name: 'app',
  data () {
    return {
      header: {
        title: 'OMDb API',
        subtitle: 'The Open Movie & TV Show Database'
      },
      showButton: false,
      search: '',
      dataFilm: '',
      showError: false,
      msnError: '',
      dataDetailFilm: '',
      showPagination: false,
      pagination: {
        pagActual: 1,
        totalRecords: 0,
        totalPages: 0
      },
      showloading: false,
      noImage: './dist/no-image.png'
    }
  },
  methods: {
    searchFilm () {
      this.showloading = true
      const params = {
        title: this.search,
        page: this.pagination.pagActual
      }
      API.getFilmData(params)
        .then(data => {
          this.showloading = false
          this.dataDetailFilm = ''
          if (data.Response === 'True') {
            this.showError = false
            this.msnError = ''
            this.dataFilm = data.Search
            this.pagination.totalRecords = data.totalResults
            this.pagination.totalPages = (data.totalResults / 10) % 1 === 0 ? parseInt((data.totalResults / 10)) : parseInt((data.totalResults / 10)) + 1
            this.showPagination = true
          } else {
            this.dataFilm = ''
            this.showError = true
            this.msnError = data.Error
            this.showPagination = false
          }
        })
        .catch(err => {
          this.showloading = false
          console.log(`Error App.vue ${err}`)
        })
    },
    searchDetailFilm (value, type) {
      this.showloading = true
      const params = {
        [type]: value
      }
      API.getDetailFilmData(params)
        .then(data => {
          this.showloading = false
          this.dataFilm = ''
          this.showPagination = false
          if (data.Response === 'True') {
            this.showError = false
            this.msnError = ''
            this.dataDetailFilm = data
          } else {
            this.dataDetailFilm = ''
            this.showError = true
            this.msnError = data.Error
          }
        })
        .catch(err => {
          this.showloading = false
          console.log(`Error App.vue ${err}`)
        })
    },
    previous () {
      this.pagination.pagActual = --this.pagination.pagActual < 1 ? 1 : this.pagination.pagActual--
      this.searchFilm()
    },
    next () {
      this.pagination.pagActual = ++this.pagination.pagActual > this.pagination.totalPages ? this.pagination.totalPages : this.pagination.pagActual++
      this.searchFilm()
    }
  },
  computed: {
    checkSearch () {
      return this.search.length === 0 ? false : true
    },
    showFilm () {
      return this.dataFilm === '' ? false : true
    },
    showDetailFilm () {
      return this.dataDetailFilm === '' ? false : true
    },
    printPages () {
      return `${this.pagination.pagActual} de ${this.pagination.totalPages}`
    }
  }
}
</script>

<style>
body {
  background-color: #0a0f1d;
  margin: 0;
  padding: 0;
}

.bg-primary {
  background-color: rgba(0, 209, 255, 0.1);
  border-bottom: 1px solid rgba(0, 209, 255, 0.2);
}

.text-white {
  color: #ffffff;
}

.lds-ripple {
  display: inline-block;
  position: absolute;
  width: 64px;
  height: 64px;
  top: calc(50% - 32px);
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #00d1ff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 28px;
    left: 28px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: -1px;
    left: -1px;
    width: 58px;
    height: 58px;
    opacity: 0;
  }
}
table {
  width: 100%;
}
table tr td,
table tr th {
  border: 1px solid #cccccc;
  padding: 5px;
  margin: 0;
  text-align: left;
}
.pagination {
  float: right;
  width: 100px;
  text-align: center;
  padding: 3px;
}
.pagination span {
  cursor: pointer;
}
.btn-wow {
  background: linear-gradient(45deg, #00d1ff, #004e66);
  padding: 12px 25px;
  font-size: 12px;
  text-align: center;
  color: #fff;
  border: none;
  border-radius: 30px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 5px 15px rgba(0, 209, 255, 0.4);
}

.btn-wow:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 209, 255, 0.6);
  filter: brightness(1.2);
}

.btn-wow.secondary {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.btn-wow.secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: #00d1ff;
}

.film-card-premium {
  position: relative;
  width: 100% !important;
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  border-radius: 24px !important;
  padding: 0 !important;
  margin-bottom: 30px !important;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.film-card-premium:hover {
  transform: scale(1.01) translateY(-5px);
  border-color: rgba(0, 209, 255, 0.3) !important;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.6);
}

.card-inner {
  display: flex;
  padding: 25px;
  gap: 30px;
  align-items: center;
}

.image-container {
  width: 200px;
  flex-shrink: 0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.poster-img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.film-card-premium:hover .poster-img {
  transform: scale(1.1);
}

.data-content {
  flex-grow: 1;
  text-align: left;
}

.film-title-gradient {
  font-size: 2.8em !important;
  margin: 10px 0 !important;
  background: linear-gradient(to right, #fff, #00d1ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
}

.meta-row {
  display: flex;
  gap: 20px;
  margin-bottom: 25px;
}

.meta-item {
  background: rgba(255, 255, 255, 0.05);
  padding: 6px 15px;
  border-radius: 20px;
  font-size: 0.85em;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 8px;
}

.id-badge {
  font-family: monospace;
  color: #00d1ff;
  font-size: 0.8em;
  opacity: 0.7;
}

.action-row {
  display: flex;
  gap: 15px;
}

.error {
  background: rgba(255, 0, 0, 0.1);
  border: 1px solid #ff0000;
  padding: 20px;
  color: #ff0000;
  border-radius: 12px;
  margin-bottom: 20px;
}

.border {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-image: url('./assets/no-image.png');
  background-repeat: no-repeat;
  background-position: center;
  width: 298px !important;
  border-radius: 12px;
}
.image-film {
  width: 300px;
  float: left;
  margin: 0 20px 20px 0;
  height: 450px;

}
.image-data {
  border: 1px solid #cccccc;
  float: left;
  width: calc(100% - 332px);
  height: 448px;
  overflow-y: scroll;
}
.box-search {
  background: rgba(10, 15, 29, 0.6);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 40px;
  border-radius: 40px;
  margin-bottom: 50px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.search-input-wrapper {
  position: relative;
  width: 100%;
  max-width: 700px;
}

.search-icon-inside {
  position: absolute;
  left: 25px;
  top: 50%;
  transform: translateY(-50%);
  color: #00d1ff;
  opacity: 0.5;
}

.box-search input[type='search'] {
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.05);
  color: #fff;
  padding: 22px 60px;
  border-radius: 100px;
  font-size: 1.3em;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
}

.box-search input[type='search']:focus {
  outline: none;
  border-color: #00d1ff;
  background: rgba(0, 209, 255, 0.05);
  box-shadow: 0 0 30px rgba(0, 209, 255, 0.2);
}

.btn-clear {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 10px;
  font-size: 1.2em;
}

.btn-clear:hover {
  color: #fff;
}

.search-main-btn {
  padding: 18px 45px !important;
  font-size: 14px !important;
  border-radius: 50px !important;
}

.pagination-modern {
  display: flex;
  align-items: center;
  gap: 20px;
  background: rgba(255, 255, 255, 0.03);
  padding: 8px 25px;
  border-radius: 100px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.pag-btn {
  background: none;
  border: none;
  color: #00d1ff;
  cursor: pointer;
  padding: 10px;
  transition: transform 0.2s;
}

.pag-btn:disabled {
  color: #475569;
  cursor: not-allowed;
}

.pag-btn:not(:disabled):hover {
  transform: scale(1.2);
}

.pag-info {
  font-weight: 800;
  font-size: 0.9em;
  letter-spacing: 2px;
}

.box-search input[type='search']:focus {
  outline: none;
  border-color: #00d1ff;
  box-shadow: 0 0 10px rgba(0, 209, 255, 0.2);
}

ul li {
  text-align: left;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
}

ul li img {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  height: 450px;
  width: 300px;
  border-radius: 12px;
}
[v-cloak] {
  display: none;
}
header {
  background: rgba(10, 15, 29, 0.8);
  backdrop-filter: blur(10px);
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.container {
  background: transparent;
  margin-top: 20px;
  padding: 30px;
  min-height: 500px;
}

.title {
  font-size: 2.5em;
  font-weight: 900;
  color: #00d1ff;
  text-shadow: 0 0 20px rgba(0, 209, 255, 0.5);
}

.subtitle {
  font-size: 0.9em;
  color: #94a3b8;
  letter-spacing: 2px;
  text-transform: uppercase;
}

#app {
  font-family: 'Inter', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #e2e8f0;
  min-width: 850px;
}

h1, h2 {
  font-weight: 800;
  color: #fff;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.film-detail-cinematic {
  position: relative;
  background: rgba(10, 15, 29, 0.9);
  backdrop-filter: blur(30px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 32px;
  padding: 40px;
  margin-top: 40px;
  box-shadow: 0 50px 100px rgba(0,0,0,0.8);
}

.btn-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  color: #fff;
  padding: 8px 15px;
  border-radius: 20px;
  cursor: pointer;
  z-index: 10;
}

.detail-header {
  display: flex;
  gap: 50px;
}

.detail-poster-container {
  flex-shrink: 0;
  width: 350px;
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0,0,0,0.5);
}

.detail-poster {
  width: 100%;
  display: block;
}

.detail-info-main {
  flex-grow: 1;
  text-align: left;
}

.detail-top {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.detail-top span {
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 0.8em;
  font-weight: 800;
  background: rgba(0, 209, 255, 0.1);
  color: #00d1ff;
  border: 1px solid rgba(0, 209, 255, 0.2);
}

.detail-title {
  font-size: 4em !important;
  margin: 0 0 10px 0 !important;
  line-height: 1 !important;
  background: linear-gradient(to bottom, #fff, #94a3b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.detail-genre {
  font-size: 1.2em;
  color: #00d1ff;
  font-weight: 700;
  margin-bottom: 30px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.detail-ratings {
  display: flex;
  gap: 20px;
  margin-bottom: 40px;
}

.rating-box {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 15px 25px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rating-source {
  font-size: 0.7em;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.rating-value {
  font-size: 1.4em;
  font-weight: 900;
  color: #00d1ff;
}

.detail-plot {
  margin-bottom: 40px;
}

.detail-plot h3 {
  font-size: 0.8em;
  color: #64748b;
  letter-spacing: 2px;
  margin-bottom: 10px;
}

.detail-plot p {
  font-size: 1.1em;
  line-height: 1.6;
  color: #cbd5e1;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  padding: 30px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 20px;
}

.grid-item {
  display: flex;
  flex-direction: column;
}

.grid-label {
  font-size: 0.7em;
  color: #64748b;
  margin-bottom: 5px;
}

.grid-value {
  font-weight: 700;
}

.animate-fade-in {
  animation: fadeIn 0.8s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

a {
  color: #00d1ff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue